import { useApp } from "context";
import { Link, Typography } from "@mui/material";

export const TermsAndConditions = () => {
  const { theme } = useApp();

  return (
    <>
      <Typography
        sx={{ textTransform: "uppercase", fontWeight: theme.font.bold }}
      >
        GENERAL
      </Typography>
      <br />
      <Typography>
        Before you access or use the Site, please read these Terms and
        Conditions carefully. These website terms and conditions of use for
        Qubehub.com constitute a legal agreement and are entered into by and
        between you and{" "}
        <b>
          Qube Hub Inc., Qube Medical Inc., Qube Health Inc., and Qasim
          Technologies Inc.
        </b>
        , (collectively as "<b>Qube</b>") Canadian corporations having their
        office at 70 University Ave. M5J2M4, Suite 120, hereinafter referred to
        as the ("<b>Company</b>"), The following terms and conditions ("
        <b>Terms and Conditions</b>"), govern your access to and use of,
        including any content, functionality, and services offered on or through
        Qubehub.com (the "<b>Platform</b>," "<b>Website</b>").
      </Typography>
      <br />
      <Typography
        sx={{ textTransform: "uppercase", fontWeight: theme.font.bold }}
      >
        BY USING THE PLATFORM AND OR WEBSITE, YOU ACCEPT AND AGREE TO BE BOUND
        AND COMPLY WITH THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE TO THESE
        TERMS AND CONDITIONS, YOU MUST NOT ACCESS OR USE THE WEBSITE. THIS
        DOCUMENT IS LEGALLY BINDING WITH THE USER AND THE PLATFORM
      </Typography>
      <br />

      <Typography>
        We may amend these Terms and Conditions at any time in our sole
        discretion, with or without notice to you. The latest version of the
        Terms and Conditions will always be posted on this page. Any such
        amendments to these Terms and Conditions will be effective as of the
        updated Last Modified Date. By accessing or using the Site on or after
        the updated Last Modified Date, you indicate to us that you accept and
        agree to the amended Terms and Conditions.
      </Typography>
      <br />

      <Typography
        sx={{ textTransform: "uppercase", fontWeight: theme.font.bold }}
      >
        DEFINITION
      </Typography>
      <br />

      <Typography component="div">
        For the purpose of these Terms of Use ("<b>Terms</b>"), wherever the
        context so requires,
        <ul>
          <li>
            "We", "Our", and "Us" shall mean and refer to the Platform, mobile
            Application and/or the Company, as the context so requires.
          </li>
          <li>
            "You/Yourself/User/Users" shall mean and refer to natural and legal
            individuals .The Users must be competent to enter into binding
            contracts, as per the laws governing Canada and the Province of
            Ontario.
          </li>
          <li>
            "Services" refer to providing a Platform which enables the Users to
            automate the process of manual scheduling and enable their patients
            to book appointments with QUBE through their booking link on the
            Platform. The Services are set out in detail under section TERMS a)
            Services.{" "}
          </li>
          <li>
            "Customers" or "Patient" shall refer to the Users of the Platform,
            who will use the platform for booking appointments with the Company
            or its Clinics.
          </li>
          <li>
            "Third Parties" refer to any Application, Companies or individual
            apart from the User and the Company.
          </li>
          <li>
            "Parties/Party" The Users and the Company shall be together referred
            to as Parties and individually as Party.
          </li>
          <li>
            "Policy/Terms" shall refer to the Terms and conditions of Service
            and Privacy policy
          </li>
          <li>
            The term "Platform" refers to details of which are set out in the
            GENERAL section to the present Terms and Conditions of Use.
          </li>
        </ul>
      </Typography>
      <br />

      <Typography
        sx={{ textTransform: "uppercase", fontWeight: theme.font.bold }}
      >
        TERMS
      </Typography>
      <br />

      <Typography component="div">
        <ol className="lower-alpha">
          <li>
            Services
            <br />
            The Company provides and supports the technology which enables the
            User access to Health Care Providers ("<b>HCP</b>") along with all
            necessary support and technology services prior to, during, and
            after your visit at any QUBE. The Platform allows Users to book
            appointments, log their patient visits, speak with Clinic admin
            staff to receive real time booking data, view historical medical
            information and track their patient journey. The Company is not
            responsible in any way for the Health Services or Support Services
            provided by the HCPs nor are they responsible for how they collect,
            use, disclose and retain your personal information ("PI") and
            personal health information ("PHI"). All HCPs are contractors of the
            QUBE. The Platforms enable HCPs receive PI and PHI about you through
            the Platform and to provide Health Services or Support Services to
            you. Your use of the Platforms neither establishes nor governs your
            relationship with the HCP. You acknowledge that you are our
            customer, and we reserve the right to remove or add HCPs on the
            Platform, and do not make any guarantees that you can access the
            same HCP on each visit. We may share your PHI and PI with various
            HCPs on the Platform in order to provide you appropriate continuity
            of care.
          </li>

          <li>
            Prohibited use
            <br />
            DO NOT USE THE PLATFORMS FOR MEDICAL EMERGENCIES. If you have a
            medical emergency, call 911 immediately or attend the emergency room
            of the nearest hospital or health centre. Under no circumstances
            should you attempt self-treatment based on any content of the
            Platforms. THE PLATFORMS ARE NOT SUBSTITUTES FOR THE ADVICE AND
            MEDICAL CARE BY YOUR PRIMARY DOCTOR OR HEALTHCARE PROVIDER. AS A
            CONDITION OF YOUR USE OF THE PLATFORMS, YOU WARRANT THAT: (1) YOU
            HAVE REACHED THE AGE OF MAJORITY IN YOUR JURISDICTION OF RESIDENCE
            OR YOU ARE THE LEGAL GUARDIAN OF THE INDIVIDUAL USING THE PLATFORM
            AND CONSENT TO THEIR USE OF THE PLATFORM; (2) YOU POSSESS THE LEGAL
            AUTHORITY TO CREATE A BINDING LEGAL OBLIGATION; (3) YOU WILL USE THE
            PLATFORMS IN ACCORDANCE WITH THESE TERMS OF USE; (4) ALL INFORMATION
            SUPPLIED BY YOU ON THE PLATFORM IS TRUE, ACCURATE, CURRENT AND
            COMPLETE; AND (5) IF YOU ARE ACCESSING OR USING THE PLATFORM ON
            BEHALF OF ANOTHER PERSON OR A CORPORATE ENTITY, YOU REPRESENT AND
            WARRANT THAT YOU HAVE THE AUTHORITY TO BIND SUCH PERSON OR ENTITY TO
            THESE TERMS OF USE.
          </li>

          <li>
            Right to Remove
            <br />
            We retain the right, at our sole discretion, to deny access to
            anyone to the Platforms or to the Health Services or Support
            Services, at any time and for any reason, including, but not limited
            to, for violation of the TOU. You will cease and desist from any
            such access or use immediately upon our request.
          </li>

          <li>
            Privacy
            <br />
            In addition to the Health Services and Support Services, the
            Platforms enable HCPs and yourself to upload and store your PHI. The
            Platforms offer optional services that we can perform on your
            behalf, and at your direction, such as the secure transfer of a
            summary report about your Health Services to a physician of your
            choice or secure transfer of your prescription to your chosen
            pharmacy or prescription delivery service. The collection, use and
            disclosure of PI and PHI are governed by our Privacy Policy. Our
            Privacy Policy is incorporated by reference into, and forms part of
            the TOU. By accessing and using the Platforms, you agree to be bound
            by its terms.
          </li>

          <li>
            User Accounts
            <br />
            In order to use the Platform and access Health Services or Support
            Services, you will be required to create a user account (the "User
            Account") and obtain a username and password login credentials
            ("User ID"). You are responsible for keeping your User ID secure. We
            reserve the right to disable any User Account issued to you at any
            time in our sole discretion. If we disable access to a User Account
            issued to you, you may be prevented from accessing the Platforms,
            any content, your account details or any User content.
          </li>

          <li>
            Intellectual Property
            <br />
            All right, title and interest in and to the Platform, together with
            all intellectual property rights therein and relating thereto,
            including but not limited to all patent, copyright, trademark,
            industrial design, trade secret, and all other intellectual property
            laws governed by statute, jurisprudence or common law, are our
            property or the property of our licensors. Except as granted in the
            Limited Licenses (as defined below) herein, any use, modification,
            transmission, distribution, republication, or other exploitation of
            the Platform, whether in whole or in part, is prohibited without our
            express prior written consent. Neither this TOU nor your use of the
            Platform convey or grant to you any rights to use or reference in
            any manner our brand elements, company names, logos, trademarks or
            services marks or those of our licensors.
          </li>

          <li>
            Limited License
            <br />
            Subject to the terms and conditions of this TOU, you are hereby
            granted a limited, non-transferable, and non-exclusive license to
            access, view, and use the Platforms for your personal,
            non-commercial use in accordance with this TOU. Access to the
            Platforms for any other purpose is prohibited. You must also: abide
            by any additional requirements governing the use of any special
            content that may be set out in the Platforms or any Platforms; and
            if a period of time for which license rights are granted to you is
            prescribed (such as a subscription term or other period of time),
            you may only use the Software during such period of time. In the
            event of a conflict between the terms of a license governing
            particular content and this TOU, the terms of the specific license
            will govern. ALL SOFTWARE EMBEDDED OR INTEGRATED INTO THE PLATFORMS
            IS PROVIDED "AS IS", WITHOUT WARRANTIES OF ANY KIND, EITHER
            EXPRESSED OR IMPLIED, INCLUDING, WITHOUT LIMITATIONS, ANY WARRANTY
            THAT THE SOFTWARE: (I) IS OF MERCHANTABLE QUALITY AND/OR IS FIT FOR
            ANY PARTICULAR PURPOSE; (II) WILL CONFORM WITH ANY SPECIFICATIONS
            RELATING TO THE SOFTWARE; (III) WILL BE FREE FROM MATERIAL DEFECTS;
            (IV) CONTAINS NO COMPUTER VIRUSES OR OTHER CONTAMINANTS; OR (V)
            SHALL PROCESS DATE AND TIME- RELATED DATA WITHOUT CAUSING ANY
            PROCESSING INTERRUPTIONS, ABNORMAL TERMINATION OR PROCESS OR
            MANIPULATE ANY TIME-RELATED DATA.12) Rules of Conduct
          </li>

          <li>
            Payment for Health Services and Support Services
            <br />
            All fees for Health Services and Support Services are in Canadian
            dollars and are inclusive of all applicable taxes.
          </li>

          <li>
            Appointment Cancellation and No-Show; Refunds
            <br />
            Subject to the terms and conditions of this TOU, you are hereby
            granted a limited, non-transferable, and non-exclusive license to
            access, view, and use the Platforms for your personal,
            non-commercial use in accordance with this TOU. Access to the
            Platforms for any other purpose is prohibited. You must also: abide
            by any additional requirements governing the use of any special
            content that may be set out in the Platforms or any Platforms; and
            if a period of time for which license rights are granted to you is
            prescribed (such as a subscription term or other period of time),
            you may only use the Software during such period of time. In the
            event of a conflict between the terms of a license governing
            particular content and this TOU, the terms of the specific license
            will govern. ALL SOFTWARE EMBEDDED OR INTEGRATED INTO THE PLATFORMS
            IS PROVIDED "AS IS", WITHOUT WARRANTIES OF ANY KIND, EITHER
            EXPRESSED OR IMPLIED, INCLUDING, WITHOUT LIMITATIONS, ANY WARRANTY
            THAT THE SOFTWARE: (I) IS OF MERCHANTABLE QUALITY AND/OR IS FIT FOR
            ANY PARTICULAR PURPOSE; (II) WILL CONFORM WITH ANY SPECIFICATIONS
            RELATING TO THE SOFTWARE; (III) WILL BE FREE FROM MATERIAL DEFECTS;
            (IV) CONTAINS NO COMPUTER VIRUSES OR OTHER CONTAMINANTS; OR (V)
            SHALL PROCESS DATE AND TIME- RELATED DATA WITHOUT CAUSING ANY
            PROCESSING INTERRUPTIONS, ABNORMAL TERMINATION OR PROCESS OR
            MANIPULATE ANY TIME-RELATED DATA.12) Rules of Conduct
          </li>

          <li>
            Consent to Advertisement; No Endorsements
            <br />
            By using the Platforms, you consent to us posting advertisement
            materials in the medical questionnaires presented to you or on other
            parts of the Platforms. Unless expressly stated, we do not recommend
            or endorse any particular brand of products, services, procedures,
            or other information that appears or is advertised from time to time
            on the Platforms.
          </li>

          <li>
            Disclaimer
            <br />
            THE PLATFORMS ARE PROVIDED "AS IS". WHILE WE ENDEAVOR TO PROVIDE
            ACCURATE, CURRENT, AND TIMELY INFORMATION, WE MAKE NO
            REPRESENTATION, WARRANTIES OR COVENANTS, EXPRESS OR IMPLIED,
            REGARDING THE PLATFORMS YOU ACKNOWLEDGE AND AGREE THAT YOUR ACCESS
            AND USE OF THE PLATFORMS IS SOLELY AT YOUR OWN RISK AND LIABILITY.
          </li>

          <li>
            Limitation of Liability
            <br />
            WE SHALL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
            PUNITIVE OR CONSEQUENTIAL DAMAGES, INCLUDING PROFESSIONAL
            NEGLIGENCE, PERSONAL INJURY, LOST INCOME OR LOST DATA, RELATED TO,
            IN CONNECTION WITH, OR OTHERWISE RESULTING FROM ANY MISUSE OF THE
            PLATFORMS AND/OR HEALTH SERVICES AND/OR SUPPORT SERVICES PROVIDED BY
            HEALTH CARE PROVIDERS. WE, OUR DIRECTORS, OFFICERS, EMPLOYEES,
            SHAREHOLDERS, AFFILIATES, AGENTS AND INDEPENDENT THIRD-PARTY
            CONTRACTORS SHALL NOT BE LIABLE FOR ANY DAMAGES, LIABILITY OR LOSSES
            ARISING OUT OF: (i) YOUR USE OF OR RELIANCE ON THE PLATFORMS AND/OR
            HEALTH SERVICES AND/OR SUPPORT SERVICES, OR YOUR INABILITY TO ACCESS
            OR USE THE PLATFORMS AND/OR HEALTH SERVICES AND/OR SUPPORT SERVICES.
            WE SHALL NOT BE LIABLE FOR DELAY OR FAILURE IN PERFORMANCE RESULTING
            FROM CAUSES BEYOND OUR REASONABLE CONTROL. WE DISCLAIM ANY AND ALL
            LIABILITIES FOR THE ACTS, OMISSIONS, AND CONDUCT OF ANY THIRD- PARTY
            USER OF THE PLATFORM, OR ANY ADVERTISER OR SPONSOR OF THE PLATFORM
            (COLLECTIVELY, "THIRD-PARTY"). UNDER NO CIRCUMSTANCES SHALL WE OR
            OUR OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES, AGENTS, LICENSORS,
            OR THEIR RESPECTIVE SUCCESSORS AND ASSIGNS BE LIABLE FOR ANY INJURY,
            LOSS, DAMAGE OF ANY KIND (INCLUDING BUT NOT LIMITED TO DIRECT,
            INDIRECT, SPECIAL, PUNITIVE, INCIDENTAL, OR CONSEQUENTIAL DAMAGES),
            OR EXPENSE ARISING IN ANY FASHION WHATSOEVER FROM: THE ACTS,
            OMISSIONS, OR CONDUCT OF ANY THIRD-PARTY, AND ANY ACCESS, USE,
            RELIANCE UPON OR INABILITY TO USE ANY MATERIALS, CONTENT, GOODS, OR
            SERVICES LOCATED AT, OR MADE AVAILABLE AT, ANY WEBSITE LINKED TO OR
            FROM THE PLATFORMS, REGARDLESS OF THE CAUSE AND WHETHER ARISING IN
            CONTRACT (INCLUDING BUT LIMITED TO FUNDAMENTAL BREACH), TORT
            (INCLUDING BUT NOT LIMITED TO NEGLIGENCE), OR OTHERWISE. THE
            FOREGOING LIMITATION SHALL APPLY EVEN IF OWNER KNEW OF OR OUGHT TO
            HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES.
          </li>

          <li>
            Indemnity
            <br />
            You agree to indemnify, defend, and hold us, our officers,
            directors, employees, affiliates, agents, licensors, and their
            respective successors and assigns, harmless from and against any and
            all claims, demands, liabilities, costs, or expenses whatsoever,
            including, without limitation, legal fees and disbursements,
            resulting directly or indirectly from your breach of any of the
            terms and conditions of this TOU your access to, use, misuse,
            reliance upon, or inability to access or use the Platforms or any
            website to which the Platforms is or may be linked to from time to
            time; or your use of, reliance on, publication, communication,
            distribution, uploading, or downloading of anything on or from the
            Platforms; or the provision of any Health Services or Support
            Services or any breach of privacy or security involving your PI or
            PHI.
          </li>

          <li>
            Modification to the Platform
            <br />
            We reserve the right at any time, and from time to time, to modify
            or discontinue, temporarily or permanently, the Platforms or any
            part thereof with or without notice to you. We shall not be liable
            to you or any third party for any modifications, suspension, or
            discontinuance of the Platforms or any part thereof.
          </li>

          <li>
            Governing Law
            <br />
            You acknowledge and agree that all matters relating to your access
            or use of the Platforms and its Content shall be governed by the
            laws of the Province of Ontario and the laws of Canada applicable
            therein, without regard to principles of conflicts of law. You agree
            and hereby submit to the exclusive jurisdiction of the courts of the
            Province of Ontario with respect to all matters relating to your
            access and use of the Platforms, as well as any dispute that may
            arise therefrom.
          </li>

          <li>
            Severability
            <br />
            If any provision of this TOU is determined to be invalid or
            unenforceable, in whole or in part, by any court of competent
            jurisdiction, the remaining provisions of this TOU continue in full
            force and effect.
          </li>

          <li>
            Waiver
            <br />
            Any consent by us, either express or implied, to, or waiver of, a
            breach of this TOU which you have committed shall not constitute a
            consent to, or waiver of, any other or subsequent breach.
          </li>

          <li>
            Non-assignment
            <br />
            The TOU is not assignable, transferable, or to be sublicensed by you
            except with our prior written consent. We may assign, transfer, or
            delegate any of our rights and obligations hereunder without your
            consent.
          </li>

          <li>
            Entire Agreement
            <br />
            This TOU and the Privacy Policy constitute the entire Agreement
            between you and us relating to your access and use of the Platforms.
            This TOU supersedes and invalidates all prior representations,
            warranties, understandings, and agreements between you and us
            relating to the subject matter of this TOU.
          </li>
        </ol>
      </Typography>
      <br />

      <Typography
        sx={{ textTransform: "uppercase", fontWeight: theme.font.bold }}
      >
        CONTACT US
      </Typography>
      <br />

      <Typography>
        Questions or comments regarding the Platforms should be directed to the
        Platform Administrator at{" "}
        <Link href="mailto:admin@qubehub.com">admin@qubehub.com</Link>
      </Typography>
      <br />
    </>
  );
};
